import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { FacultyFormValues } from "src/models/Faculty.model";
import Faculty from "../Layouts/FacultyForm";
import { showToast } from "src/utils/showToaster";
import { useAddFacultyMutation } from "src/services/FacultyService";

type Props = {
  onClose: () => void;
};

const AddFacultyWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: FacultyFormValues = {
    facultyName: "",
    facultyCode: "",
    institute: [],
    facultyImage: '',
    facultyDescription: "",
    rank: "",
  };

  // Validation Schema
const validationSchema = object().shape({
  facultyName: string().required("Please enter faculty name"),

  institute: array()
    .of(
      object().required("please select institute")
    )
    .min(1, "Please select at least one institute")
    .required("Please select institute name"),

  facultyCode: string().required("Please enter faculty code"),
});

  const [addFaculty] = useAddFacultyMutation();

  // Handle Submit
  const handleSubmit = (
    values: FacultyFormValues,
    { setSubmitting, resetForm }: FormikHelpers<FacultyFormValues>
  ) => {
    const payload = {
      facultyName: values.facultyName,
      facultyCode: values.facultyCode,
      facultyImage: values.facultyImage,
      facultyDescription: values.facultyDescription,
      rank: values.rank,  
      institute: values.institute?.map((ins) => ins.value),
    };
    addFaculty(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Faculty
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddFacultyWrapper;
